import { Grid } from '@mui/material';
import { isEmpty } from 'lodash-es';
import { ICandidate } from 'wisestep-api';
import { WsTypography } from 'wisestep-base';

import { useCandidateViewData } from '../../../utils/CandidateViewContext';
import CardWithAccordion from '../CardWithAccordion';

export interface CandidateCertificateCardProps {
  title: string;
  candidate: ICandidate;
}

const CandidateCertificateCard = ({ title, candidate }: CandidateCertificateCardProps) => {
  const [firstCertification, ...remainingCertifications] =
    candidate?.candidateCertificationsData ?? [];
  const { candidateViewData } = useCandidateViewData();
  const isInDnc =
    (candidateViewData?.dnc?.isDeleted ?? false) || (candidateViewData?.dnc?.isInDnc ?? false);

  return (
    <CardWithAccordion
      title={title}
      topChild={
        <>
          {isInDnc && (
            <Grid xs={12} ml={7.5}>
              <WsTypography>No Data To Show</WsTypography>
            </Grid>
          )}
          {!isInDnc && !isEmpty(firstCertification) && firstCertification && (
            <Grid container alignItems="center" justifyContent="space-between" sx={{ p: 1 }}>
              <Grid item>
                {firstCertification.name && (
                  <WsTypography bold={true}>{firstCertification?.name}</WsTypography>
                )}
              </Grid>
              {firstCertification?.startDate &&
                firstCertification.startDate.year > 0 &&
                firstCertification.startDate.month > 0 &&
                firstCertification?.endDate &&
                firstCertification.endDate.year > 0 &&
                firstCertification.endDate.month > 0 && (
                  <Grid item>
                    <WsTypography>
                      {`${new Date(
                        firstCertification?.startDate.year,
                        firstCertification?.startDate.month - 1
                      ).toLocaleDateString('en-US', { month: 'short' })} ${
                        firstCertification?.startDate.year
                      }`}
                      {' to '}
                      {`${new Date(
                        firstCertification?.endDate.year,
                        firstCertification?.endDate.month - 1
                      ).toLocaleDateString('en-US', { month: 'short' })} ${
                        firstCertification?.endDate.year
                      }`}
                    </WsTypography>
                  </Grid>
                )}

              <Grid item xs={12} sx={{ mt: 1 }}>
                <WsTypography>
                  {firstCertification?.company && (
                    <>
                      {firstCertification?.company}{' '}
                      <Grid component="span" sx={{ paddingLeft: '8px', paddingRight: '8px' }}>
                        {firstCertification?.licenseNumber &&
                          `Lic. no ${firstCertification?.licenseNumber}`}
                      </Grid>
                      {' | '}
                    </>
                  )}
                  {firstCertification?.score && firstCertification?.score > 0 && (
                    <Grid component="span" sx={{ paddingLeft: '8px' }}>
                      Score: {firstCertification?.score}
                    </Grid>
                  )}
                </WsTypography>
              </Grid>
            </Grid>
          )}
        </>
      }
      bottomChild={
        <>
          {!isInDnc &&
            !isEmpty(remainingCertifications) &&
            remainingCertifications?.map((certification, index) => (
              <Grid
                key={index}
                container
                alignItems="center"
                justifyContent="space-between"
                sx={{ p: 1 }}
              >
                <Grid item>
                  {certification.name && (
                    <WsTypography bold={true}>{certification.name}</WsTypography>
                  )}
                </Grid>
                {certification?.startDate && certification?.endDate && (
                  <Grid item>
                    <WsTypography>
                      {certification?.startDate.year > 0 &&
                        certification.startDate.month > 0 &&
                        certification?.endDate.year > 0 &&
                        certification?.endDate.month > 0 && (
                          <Grid item>
                            <WsTypography>
                              {`${new Date(
                                certification?.startDate.year,
                                certification?.startDate.month - 1
                              ).toLocaleDateString('en-US', { month: 'short' })} ${
                                certification?.startDate.year
                              }`}
                              {' to '}
                              {`${new Date(
                                certification?.endDate.year,
                                certification?.endDate.month - 1
                              ).toLocaleDateString('en-US', { month: 'short' })} ${
                                certification?.endDate.year
                              }`}
                            </WsTypography>
                          </Grid>
                        )}
                    </WsTypography>
                  </Grid>
                )}
                <Grid item xs={12} sx={{ mt: 1 }}>
                  <WsTypography>
                    {certification?.company && (
                      <>
                        {certification?.company}{' '}
                        <Grid component="span" sx={{ paddingLeft: '8px', paddingRight: '8px' }}>
                          {certification?.licenseNumber &&
                            `Lic. no ${certification?.licenseNumber}`}
                        </Grid>
                        {' | '}
                      </>
                    )}
                    {certification?.score && certification?.score > 0 && (
                      <Grid component="span" sx={{ paddingLeft: '8px' }}>
                        Score: {certification?.score}
                      </Grid>
                    )}
                  </WsTypography>
                </Grid>
              </Grid>
            ))}
        </>
      }
      hasData={!isEmpty(firstCertification) || !isEmpty(remainingCertifications)}
    />
  );
};

export default CandidateCertificateCard;
